var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenDownAngle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ml-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.251049 0.756267C-0.083683 1.09796 -0.083683 1.65201 0.251049 1.9937L5.39392 7.24373C5.72864 7.58542 6.27138 7.58542 6.6061 7.24373L11.749 1.9937C12.0837 1.65201 12.0837 1.09796 11.749 0.756267C11.4142 0.414577 10.8715 0.414577 10.5368 0.756267L6.00001 5.38758L1.46324 0.756267C1.1285 0.414578 0.58579 0.414578 0.251049 0.756267Z",
    fill: "#64B200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDownAngle);
export default __webpack_public_path__ + "static/media/greenDownAngle.851e0bdc99b03b5c1d1777e9bfcd50c6.svg";
export { ForwardRef as ReactComponent };